import { makeAutoObservable } from "mobx";
import Configuracion from "../api/configuracion/configuracion";
import { getError } from "../util/util";

export class ConfiguracionStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  loading = false;

  consultarParametro = async (clave) => {
    this.loading = true;
    try {
      const result = await Configuracion.consultarParametro(clave);
      if (result.success) return Promise.resolve(result.data);
      else return Promise.resolve(null);
    } catch (error) {
      // Alertas
      this.displayError(error);
      return Promise.resolve(null);
    } finally {
      this.loading = false;
    }
  };

  getParameter = async (clave) => {
    this.loading = true;
    try {
      const result = await Configuracion.getParameter(
        clave,
        parseInt(process.env.REACT_APP_ID_ORGANIZATION)
      );
      if (result.success) return Promise.resolve(result.data);
      else return Promise.resolve(null);
    } catch (error) {
      this.displayError(error);
      return Promise.reject(null);
    } finally {
      this.loading = false;
    }
  };

  displayError = (error) => {
    this.rootStore.alertStore.alertError(getError(error));
  };
}
